import React, { useState } from 'react';
import { Sparkles, Loader } from 'lucide-react';

export default function NaturalLanguageInput({ onBuild, loading, disabled }) {
  const [desc, setDesc] = useState('');
  const canSubmit = desc.trim().length >= 10 && desc.length <= 4000 && !loading && !disabled;

  return (
    <div className="fs-nl-input">
      <label className="fs-nl-label">
        Describe your research question in plain language
      </label>
      <textarea
        className="fs-nl-textarea"
        value={desc}
        onChange={e => setDesc(e.target.value)}
        placeholder="e.g. Randomized controlled trials of mesenchymal stem cells for knee osteoarthritis published in the last 3 years, with at least 6-month follow-up outcomes."
        rows={5}
        disabled={loading || disabled}
      />
      <div className="fs-nl-footer">
        <span className={`fs-nl-charcount ${desc.length > 3800 ? 'fs-nl-charcount--warn' : ''}`}>
          {desc.length}/4000
        </span>
        <button
          className="fs-btn fs-btn--primary"
          onClick={() => onBuild(desc.trim())}
          disabled={!canSubmit}
        >
          {loading ? <Loader size={14} className="fs-spin" /> : <Sparkles size={14} />}
          {loading ? 'Building query…' : 'Build Query with AI'}
        </button>
      </div>
    </div>
  );
}
